<script>
export default {
    props:{
        is:{type:String, required:true}
    },
    render(h){
        return h(this.tag, this.$slots.default)
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Tag.vue